import React from 'react'

interface IconProps {
  color?: string
  size?: number
}

export const Pin: React.FC<IconProps> = ({ color = '#fff', size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path
      d="M21.957 9.822a.5.5 0 010 .707l-.707.707a.5.5 0 01-.707 0l-.354-.354-4.242 4.243-.707 3.535-1.415 1.415-4.242-4.243-4.596 4.596a.5.5 0 01-.708 0l-.707-.707a.5.5 0 010-.707l4.596-4.596-4.242-4.243L5.34 8.761l3.536-.707 4.242-4.243-.353-.353a.5.5 0 010-.707l.707-.708a.5.5 0 01.707 0l7.778 7.779z"
      fill={color}
    />
  </svg>
)
